angular.module('picmonic-common').directive('plsRegisterModal', [
  'UserService',
  function (UserService) {
    return {
      restrict: 'A',
      scope: {
        login: '<',
        redirect: '<',
        card: '<',
      },
      link: function (scope, element, attrs) {
        element.click(function () {
          UserService.showRegisterModal(scope.login, scope.redirect, scope.card);
        });
        if (UserService.user.user_id && attrs.plsRegisterModalAlwaysVisible !== '') {
          element.hide();
        }
      },
    };
  },
]);
